export const state = {
    workFlowHistoryData: [],
};


export const mutations = {
    SET_WORKFLOW_HISTORY_DATA(state, newValue) {
        state.workFlowHistoryData = newValue
    },
};



export const actions = {
    setWorkFlowHistoryData({ commit }, payload) {
        commit('SET_WORKFLOW_HISTORY_DATA', payload);
    },
}
